export const listPipelines = `
   query listPipelines($filter: PipelinesFilterInput, $limit: Int, $nextToken:  String) {
       listPipelines(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              id
              name
              description
              pipelineType
              pipelineStatus
              templateId
              codeRepositoryName
              branchName
              originalStackName
              stackName
              buildCommand
              deploymentAccountGroupId
              stages {
                name
                order
                buildProvider
                deployProvider
                requiresApproval
                stageKind
                region
              }
              deploymentAccounts {
                accountId
                accountName
                region
                deploymentBucketName
                deployRoleArn
              }
              codeRepository {
                name
                provider
                description
                defaultBranch
              }
              template {
                id
                name
                pipelineType
              }
              createdByUsername
              created
              updated
           }
           nextToken
       }
   }
`;

export const analyzeRepository = `
   query analyzeRepository($input: AnalyzeRepositoryInput!) {
       analyzeRepository(input: $input) {
           repositoryName
           branchName
           detectedArchetype
           suggestedPipelineType
           suggestedBuildCommand
           suggestedStages {
             name
             order
             buildProvider
             deployProvider
             requiresApproval
             stageKind
             region
           }
           suggestedTemplateId
           suggestedTemplateName
           suggestedPipelineName
           suggestedDeploymentAccounts {
             accountId
             accountName
             region
             deploymentBucketName
             deployRoleArn
           }
           detectedFiles
           confidence
           findings {
             key
             label
             value
             source
             evidence
             severity
           }
           recommendations {
             key
             message
             suggestion
             severity
           }
       }
   }
`;

export const getStackStatus = `
   query getStackStatus($stackName: String!) {
       getStackStatus(stackName: $stackName) {
         stackName
         status
         statusReason
       }
   }
`;

export const getPipeline = `
   query getPipeline($id:ID!) {
       getPipeline(id:$id) {
         id
         name
         description
         pipelineType
         pipelineStatus
         templateId
         codeRepositoryName
         branchName
         originalStackName
         stackName
         buildCommand
         deploymentAccountGroupId
         stages {
           name
           order
           buildProvider
           deployProvider
           requiresApproval
           stageKind
           region
         }
         deploymentAccounts {
           accountId
           accountName
           region
           deploymentBucketName
           deployRoleArn
         }
         codeRepository {
           name
           provider
           description
           cloneUrlHttp
           cloneUrlSsh
           arn
           defaultBranch
         }
         template {
           id
           name
           description
           pipelineType
           archetype
         }
         createdByUsername
         managedByUsername
         created
         updated
       }
}`;
